import { render, staticRenderFns } from "./Workshop2.vue?vue&type=template&id=2549fc37&"
import script from "./Workshop2.vue?vue&type=script&lang=js&"
export * from "./Workshop2.vue?vue&type=script&lang=js&"
import style0 from "./Workshop2.vue?vue&type=style&index=0&id=2549fc37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports